import { jsxs as m, jsx as l } from "react/jsx-runtime";
import { f as c } from "../../chunks/find-key-value.B24OOzGv.js";
import { Placeholder as o } from "@sitecore-jss/sitecore-jss-nextjs";
const h = ({ rendering: a, componentFactory: s }) => {
  const t = c(
    a.placeholders,
    "componentName",
    "InteriorNavigation"
  );
  return /* @__PURE__ */ m("div", { "data-test-id": a == null ? void 0 : a.componentName, children: [
    /* @__PURE__ */ l(o, { name: "col-top", rendering: a, componentFactory: s }),
    t ? /* @__PURE__ */ l("div", { className: "neu-bg-plain-0", children: /* @__PURE__ */ m("div", { className: "d-lg-flex container", children: [
      /* @__PURE__ */ l("div", { className: "w-lg-25 w-100 pe-0 pe-lg-1 pt-6", children: /* @__PURE__ */ l(o, { name: "aside", rendering: a }) }),
      /* @__PURE__ */ l("div", { className: "w-lg-75 w-100 ps-0 ps-lg-1", children: /* @__PURE__ */ l(o, { name: "col-1", rendering: a, componentFactory: s }) })
    ] }) }) : /* @__PURE__ */ l(o, { name: "col-1", rendering: a, componentFactory: s }),
    /* @__PURE__ */ l(o, { name: "col-bottom", rendering: a, componentFactory: s })
  ] });
};
export {
  h as OneColumnLayout
};
